/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ImageContentType = "GIF" | "JPEG" | "PNG" | "WEBP" | "%future added value";
export type SponsorsSectionSponsor_guildSponsorship = {
    readonly rowId: string;
    readonly description: string;
    readonly webUrl: string;
    readonly linkText: string;
    readonly lightModeImage: {
        readonly rowId: string;
        readonly contentType: ImageContentType;
        readonly width: number | null;
        readonly height: number | null;
    } | null;
    readonly guild: {
        readonly name: string;
    } | null;
    readonly " $refType": "SponsorsSectionSponsor_guildSponsorship";
};
export type SponsorsSectionSponsor_guildSponsorship$data = SponsorsSectionSponsor_guildSponsorship;
export type SponsorsSectionSponsor_guildSponsorship$key = {
    readonly " $data"?: SponsorsSectionSponsor_guildSponsorship$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SponsorsSectionSponsor_guildSponsorship">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SponsorsSectionSponsor_guildSponsorship",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "lightModeImage",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "width",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Guild",
      "kind": "LinkedField",
      "name": "guild",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GuildSponsorship",
  "abstractKey": null
};
})();
(node as any).hash = '7a0ddff499b4c45adb2b8cc0c294f46e';
export default node;
